/**
 * MC Product Accordion — menus déroulants de la colonne d'achat (fiche produit).
 *
 * Pourquoi ce fichier plutôt que le `handleDropdown()` global (mm-global.js) :
 *
 * 1. `handleDropdown()` ouvre par défaut le PREMIER [data-drop="dropdown"] de la
 *    page, qui sur une fiche produit est celui du menu mobile — jamais celui de
 *    la colonne d'achat. Impossible donc d'ouvrir la description par défaut sans
 *    intervenir.
 * 2. Il attache ses écouteurs une fois pour toutes au chargement. Dès que la
 *    section est re-rendue (éditeur de thème, rechargement de section), on se
 *    retrouve avec DEUX gestionnaires sur le même clic : ils se neutralisent —
 *    le menu ne se ferme plus, et plus rien ne s'ouvre ensuite.
 *
 * Ce module reprend donc ces menus à son compte :
 *   - il remplace chaque en-tête par un clone (tout écouteur étranger déjà posé
 *     disparaît avec l'ancien nœud) ;
 *   - il renomme leur attribut en data-drop="mc-product-dropdown", ce qui les
 *     sort définitivement du champ de `handleDropdown()` ;
 *   - il est idempotent : rejoué dix fois, le comportement reste identique.
 *
 * Comportement conservé à l'identique : un seul menu ouvert à la fois, clic sur
 * un menu ouvert = fermeture, animation par max-height.
 */
(function () {
	'use strict';

	var BLOCK = '.mm-product-form-component-dropdown';
	var HEAD = '[data-drop="dropdown"], [data-drop="mc-product-dropdown"]';
	var OPEN = 'active';

	function init() {
		var block = document.querySelector(BLOCK);
		if (!block) return;

		var heads = Array.prototype.slice.call(block.querySelectorAll(HEAD));
		if (!heads.length) return;

		heads = heads.map(function (head) {
			var clean = head.cloneNode(true);
			clean.setAttribute('data-drop', 'mc-product-dropdown');
			clean.setAttribute('role', 'button');
			clean.setAttribute('tabindex', '0');
			clean.setAttribute('aria-expanded', 'false');
			head.parentNode.replaceChild(clean, head);
			return clean;
		});

		function panelOf(head) {
			return head.nextElementSibling;
		}

		function close(head) {
			head.classList.remove(OPEN);
			head.setAttribute('aria-expanded', 'false');
			var panel = panelOf(head);
			if (panel) panel.style.maxHeight = null;
		}

		function open(head) {
			head.classList.add(OPEN);
			head.setAttribute('aria-expanded', 'true');
			var panel = panelOf(head);
			if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
		}

		function toggle(head) {
			var wasOpen = head.classList.contains(OPEN);
			heads.forEach(close);
			if (!wasOpen) open(head);
		}

		heads.forEach(function (head) {
			head.addEventListener('click', function (event) {
				event.preventDefault();
				toggle(head);
			});

			head.addEventListener('keydown', function (event) {
				if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
				event.preventDefault();
				toggle(head);
			});
		});

		/* Description (premier menu) ouverte par défaut. */
		heads.forEach(close);
		open(heads[0]);

		/* La hauteur réelle du contenu bouge après coup (polices, images, retours
		   à la ligne) : on réaligne le max-height du menu ouvert. */
		function resync() {
			heads.forEach(function (head) {
				if (!head.classList.contains(OPEN)) return;
				var panel = panelOf(head);
				if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
			});
		}

		window.addEventListener('load', resync);
		window.addEventListener('resize', resync);

		if (window.ResizeObserver) {
			heads.forEach(function (head) {
				var panel = panelOf(head);
				var content = panel && panel.firstElementChild;
				if (content) new ResizeObserver(resync).observe(content);
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();
